import { Button, Checkbox, Col, Form, Input, Row, Select, Space } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { showError, showMessage, useLayoutBreaks } from "helpers/utility";
import useAjax from "helpers/ajax";
import CSelect from "components/CSelect";
import { useEffect, useState } from "react";

const CreateDevice = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const breaks = useLayoutBreaks();
  const { fetch, get } = useAjax();
  const edit = state ? true : false;
  const [distributors, setDistributors] = useState([]);

  const onFinish = (values) => {
    const method = edit ? "put" : "post";
    const data = { ...values, activationID: state?.activationID };
    fetch(method, "api/v1/devices", { ...data })
      .then((resp) => {
        showMessage(resp.success, resp.message).then(() => {
          if (resp.success) {
            navigate("/devices/devices");
          }
        });
      })
      .catch((err) => {
        showError(err);
      });
  };

  useEffect(() => {
    get("api/v1/lookups/distributorslineage")
      .then((resp) => {
        setDistributors(resp);
      })
      .catch((err) => {
        showError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      layout="vertical"
      initialValues={{
        ...state,
        active: !edit ? true : state.active,
        compatible: !edit ? true : state.compatible,
      }}
      onFinish={onFinish}
    >
      <Row gutter={24}>
        <Col {...breaks}>
          <Form.Item
            label="Distributor"
            name="companyID"
            // rules={[{ required: true }]}
          >
            <CSelect allowClear={true} dropdownMatchSelectWidth={false}>
              {distributors.map((r) => (
                <Select.Option key={r.value} value={r.value}>
                  {r.text}
                </Select.Option>
              ))}
            </CSelect>
          </Form.Item>
          <Form.Item
            label="Serial no."
            name="serialNo"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Model no."
            name="modelNo"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            valuePropName="checked"
            label="Compitable"
            name="compatible"
          >
            <Checkbox />
          </Form.Item>

          <Form.Item valuePropName="checked" label="Active" name="active">
            <Checkbox />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                Save
              </Button>
              <Button
                htmlType="button"
                onClick={() => {
                  navigate("/devices/devices");
                }}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default CreateDevice;
